export const deepCopy = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj));
};

export const trimRoleName = (role: string): string =>
  role.lastIndexOf('-') !== -1 ? role.slice(role.lastIndexOf('-') + 1) : role;
